import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';
import { AgentFlowProgress } from './model';

export const AGENT_FEATURE_KEY = 'agent';

export interface initialAgentState {
  agentDataFromFirebase: AgentFlowProgress[];
}

export const initialAgentState: initialAgentState = {
  agentDataFromFirebase: [],
};

export const agentSlice = createSlice({
  name: AGENT_FEATURE_KEY,
  initialState: initialAgentState,
  reducers: {
    updateAgentDataFromFirebase: (
      state,
      action: PayloadAction<AgentFlowProgress[]>
    ) => {
      state.agentDataFromFirebase = action.payload;
    },
  },
});

export const { updateAgentDataFromFirebase } = agentSlice.actions;

export const getAgentSliceState = (rootState: RootState): initialAgentState =>
  rootState[AGENT_FEATURE_KEY];

export const getAgentDataFromFirebase = createSelector(
  getAgentSliceState,
  (state) => state.agentDataFromFirebase
);
